// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"72857e9e","76":"58940a1e","139":"11b95d0b","317":"ced9dd8e","626":"df3e46f4","885":"c09e301d"}[chunkId] + ".chunk.js";
};